import React from 'react';
import { theme } from 'styled-tools';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useKeyConceptsContext } from 'context/Page/KeyConcepts';

const SearchContainer = styled.div`
  padding: 0.75rem;
  width: 100%;

  ${props => props.theme.breakpoints.up('sm')} {
    border-bottom: 0.0625rem solid ${theme('colors.borderGray')};
  }
`;

const StyledTextField = styled(TextField)`
  width: 100%;

  .MuiOutlinedInput-root {
    background-color: ${theme('colors.iconHoverBackgroundGray')};
    border-radius: 50px;
    box-shadow: none;
    height: 2.5rem;

    .MuiOutlinedInput-notchedOutline {
      border: 0;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border: 0;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 0;
    }
  }

  .MuiInputBase-input {
    color: #666666;
    font-family: ${theme('typography.fontFamilySecondary')};
    font-size: 0.8125rem;
    font-weight: 400;
    text-transform: uppercase;
    padding: 0 1rem;

    &::placeholder {
      color: ${theme('colors.mutedGray')};
      opacity: 1;
    }
  }
`;

const AdornmentButton = styled(IconButton)`
  color: ${theme('colors.black')};
  border-radius: 0;

  &::after {
    content: none;
  }

  &:hover {
    color: ${theme('colors.ttRed')};
    background-color: transparent;
  }

  .MuiTouchRipple-root {
    display: none;
  }

  .MuiSvgIcon-root {
    font-size: 1.1rem;
  }
`;

function SearchBar({ checkForSearchTerm, isMobileSearch = false }) {
  const { searchTerm, setSearchTerm } = useKeyConceptsContext();

  const handleSearch = (val) => {
    const value = typeof val === 'string' ? val : searchTerm;
    setSearchTerm(value);
    checkForSearchTerm(value);
  };

  const handleClear = () => {
    setSearchTerm('');
    checkForSearchTerm('');
  };

  return (
    <SearchContainer id='key-concepts-search'>
      <StyledTextField
        variant='outlined'
        placeholder='Search Key Concepts...'
        value={searchTerm}
        onChange={(e) => {
          const v = e.target.value;
          setSearchTerm(v);
          checkForSearchTerm(v); // keep live filtering; remove if you only want on Enter
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleSearch(e.currentTarget.value);
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              {searchTerm ? (
                <AdornmentButton
                  aria-label='clear'
                  onClick={handleClear}
                  edge='end'
                >
                  <CloseIcon />
                </AdornmentButton>
              ) : (
                <AdornmentButton
                  aria-label='search'
                  onClick={handleSearch}
                  edge='end'
                >
                  <SearchIcon />
                </AdornmentButton>
              )}
            </InputAdornment>
          ),
        }}
      />
    </SearchContainer>
  );
}

export default SearchBar;
